// For fade in effect
import FadeIn from 'react-fade-in';

// Styling
import './Styles.scss';

const WCSAddCluster = () => {
  return (
    <FadeIn>
      <div className='__addClusterPage'>
        <div className='wcsWrappper'>
          <div className='wcsBox'>
            <p>
              This is the legacy console for the Weaviate Cloud Service. In
              order to make use of our latest features and create sandboxes as
              well as managed clusters, please use the{' '}
              <a href='https://console.weaviate.cloud/'>new console</a> instead
              by visiting:
            </p>
            <a href='https://console.weaviate.cloud/' className='wcsLinkButton'>
              New Weaviate Console
            </a>
          </div>
        </div>
      </div>
    </FadeIn>
  );
};

export default WCSAddCluster;
